export default "__VITE_ASSET__8c802279__"